import { ENGLISH_LANGUAGE_CODE } from './constants';
import type { LanguageMapType } from './types';

export const languageMap: LanguageMapType = {
  [ENGLISH_LANGUAGE_CODE]: 'en-US',
};
